import React from "react";
import styles from "./QreativesLogo.module.scss";
import { Link } from "react-router-dom";
import CreativesLogoSVG from "components/SVGComponents/CreativesLogoSVG";
import { combineClasses } from "utils/utils";

const QreativesLogo = ({
  width = "150",
  height = "55",
  className,
  href,
  ...rest
}) => {
  return (
    <Link to={href} className={combineClasses(className)}>
      <CreativesLogoSVG height={height} width={width} />
    </Link>
  );
};

export default QreativesLogo;
